import { useSelfServeContextStore } from "./SelfServeContext";

interface IUseOrderToken {
  orderToken: string | undefined;
}

export const useOrderToken = (): IUseOrderToken => {
  const [{ selectedBrandOrder }] = useSelfServeContextStore([
    "selectedBrandOrder",
  ]);

  const orderToken = selectedBrandOrder?.brand_order?.token;

  return {
    orderToken,
  };
};
